import styled from '@emotion/styled'

export const Container = styled('div')({
  maxWidth: '660px'
})

export const Header = styled('div')({ marginTop: '14px' })

export const Wrapper = styled('div')({
  marginTop: '16px'
})
